



























































































































import Vue from "vue";
import mixins from 'vue-typed-mixins';
import StandardNavigationMixin from "@/mixins/Customizer/StandardNavigation";
import StandardNavigationBullet from "@/components/Customizer/StandardNavigation/StandardNavigationBullet";

import {
  ItemObject,
  TreeNode,
} from "@/components/Customizer/StandardNavigation/StandardNavigation.t";

export default mixins(StandardNavigationMixin).extend({
  name: "StandardNavigationItem",
  components: { StandardNavigationBullet },
  props: {
    item: {
      type: Object as () => ItemObject,
    },
    activeItemId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    focusedTreeItem: {
      type: Object as () => ItemObject,
    },
    enableTabIndex: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isExpanded: false as boolean,
      currentTabIndex: -1 as number,
    };
  },
  computed: {
    isActive(): boolean | string | any {
      if (!this.item) return false;
      return this.item.active || this.activeItemId === (this as any).id;
    },
    assetsPath(): string {
      return (this.$store as any).state.endPoints.customizer.customsAssets;
    },
    groupTabs(): any {
      return this.$store.state.swatches.groupTabs;
    }
  },
  watch: {
    ["item.expanded"](newValue) {
      this.isExpanded = newValue;
    },
  },
  methods: {
    onClickIcon(isPersonalization = false) {
      this.onActivate();
      const tab = (this.item?.hasPersonalization && isPersonalization) ?
        this.groupTabs.personalization : this.groupTabs['add-your-own'];
      this.$eventBus.$emit('changeTab', tab);
    },
    onActivate(): void {
      if (this.focusedTreeItem) {
        this.canReceiveFocus(false);
      } else {
        this.canReceiveFocus(true);
      }
      this.$emit("tree-item-received-focus", this);
      const shouldExpand = !this.isExpanded;
      if (
        shouldExpand &&
        !(this as any).multipleSameLevelNodesOpened &&
        (this as any).updateExpandedFlagOnNavigation
      ) {
        this.$emit("tree-view-item-collapse-siblings", this.item);
      }
      const parameters: TreeNode = {
        id: (this as any).id,
        hasChildren: (this as any).hasChildren,
        path: [(this as any).id],
      };

      if ((this as any).hasChildren) {
        if ((this as any).updateExpandedFlagOnNavigation)
          this.isExpanded = shouldExpand;
        if (shouldExpand) this.$emit("tree-item-expand-item", this.item);
        else this.$emit("tree-item-collapse-item", this.item);
        this.$emit("tree-item-activated", parameters);
        parameters.isExpanded = shouldExpand;
      }

      if (!(this as any).hasChildren) {
        if ((this as any).activateOnCollapse || shouldExpand)
          this.$emit("tree-item-activated", parameters);
      }
    },
    /**
     * Updates the tabindex
     */
    canReceiveFocus(value: boolean): void {
      this.currentTabIndex = value ? 0 : -1;
    },
    /**
     * Handles keyboard navigation
     */
    onMoveFocus(event: KeyboardEvent): void {
      this.$emit("tree-item-on-move-focus", event);
    },
    onFocus(): void {
      this.$emit("tree-item-on-focus", this);
    },
    /**
     * Handles the focus on the tree item
     */
    onTreeItemReceivedFocus(treeItem: Vue): void {
      this.$emit("tree-item-received-focus", treeItem);
    },
    /**
     * Updates the isExpanded data attribute
     */
    collapse(): void {
      if (this.isExpanded) this.isExpanded = false;
      this.$emit("tree-item-collapse-item", this.item);
    },
    shouldAutoSelectSubComponent() {
      if (this.activeItemId === (this as any).id) {
        if ((this as any).hasChildren) {
          this.isExpanded = true;
          this.selectSubComponent(this.activeItemId);
        }
      }
    },
    /**
     * Select the subcomponent by default
     */
    selectSubComponent(componentName: string | number): void {
      let swatchId: number;
      const { recipe_v2, defaultRecipe } = this.$store.state.recipe;
      if (recipe_v2?.recipe_id !== defaultRecipe?.recipe_id) {
        swatchId = recipe_v2.components[componentName].swatch_id;
      } else {
        swatchId = parseInt(this.$store.state.utils.pdm.default_gdm);
      }
      if(swatchId) {
        let gdmObject = this.$store.state.gdm.data.find((data : any)=> data.id === swatchId);
        this.$store.dispatch("standardNavigation/UPDATE_STANDARD_NAVIGATION",
          {"activeComponent":componentName,"activeSubComponent":gdmObject?.default_component}
        );
      }
    }
  },
  created() {
    this.shouldAutoSelectSubComponent();

    if (this.item.expanded) this.isExpanded = this.item.expanded;
    if (this.enableTabIndex) this.currentTabIndex = 0;
  },
  updated() {
    if (this.$store.state.utils.isDesignTransfering) {
      this.shouldAutoSelectSubComponent();
    }
  }
});
